import { FetchError, type FetchOptions } from 'ofetch'
import { useNuxtApp } from '#imports'

export const createApiUtils = <TResponses extends Record<string, any>>() => {
  const $api = useNuxtApp().$api as <T>(
    url: string,
    options?: FetchOptions,
  ) => Promise<T>

  const execute = <K extends keyof TResponses>(request: {
    url: string
    options: FetchOptions
  }): Promise<TResponses[K]> => {
    return $api<TResponses[K]>(request.url, request.options)
  }

  const getError = (error: unknown): FetchError | null => {
    if (error instanceof FetchError) {
      return error as FetchError
    }
    return null
  }

  return { execute, getError }
}
